import { useDispatch, useSelector } from "react-redux";
import { deleteManagementCompany } from "../services/managementService";
import { fetchManagementCompanies } from "../../../../../redux/mgmtCo/managementSlice";
import {
  clearSelectedManagement,
  selectedSelectedManagement,
} from "../../../../../redux/mgmtCo/selectedManagementSlice";
import {
  selectCurrentPage,
  selectRowsPerPage,
} from "../../../../../redux/mgmtCo/paginationSlice";

const useDeleteManagementCompany = () => {
  const dispatch = useDispatch();
  const selectedCompany = useSelector(selectedSelectedManagement);
  const currentPage = useSelector(selectCurrentPage);
  const rowsPerPage = useSelector(selectRowsPerPage);

  const deleteSelectedCompany = async () => {
    if (!selectedCompany) {
      throw new Error("Please select a management company to delete.");
    }
    try {
      // Call the delete service
      await deleteManagementCompany(selectedCompany.managementId);
      dispatch(clearSelectedManagement());
      // Re-fetch companies using current pagination values
      dispatch(
        fetchManagementCompanies({ currentPage, rowsPerPage, searchQuery: "" })
      );
      return true;
    } catch (error) {
      throw error;
    }
  };

  return deleteSelectedCompany;
};

export default useDeleteManagementCompany;
